import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Takaisin',
  },
  metrics: {
    impressions: {
      label: 'Näyttökerrat',
      description: 'Kuinka monta kertaa mainoksesi näytettiin Googlen hakutuloksissa tai kumppanisivustoilla.',
    },
    clicks: {
      label: 'Klikkaukset',
      description: 'Kuinka monta kertaa ihmiset klikkasivat mainostasi.',
    },
    budget_spent: {
      label: 'Käytetty budjetti',
      description: 'Tähän kampanjaan käytetty rahamäärä yhteensä.',
    },
    absolute_top_impression_percentage: {
      label: 'Ehdottoman ylimmän sijoituksen %',
      description: 'Prosenttiosuus kerroista, jolloin mainoksesi näkyi Googlen hakutulosten aivan ylimpänä.',
    },
    phone_calls: {
      label: 'Puhelut',
      description: 'Mainoksesi kautta vastaanotettujen puheluiden kokonaismäärä.',
    },
    phone_impressions: {
      label: 'Puhelinnumeron näyttökerrat',
      description: 'Kuinka monta kertaa puhelinnumerosi näytettiin mainoksessa.',
    },
    phone_through_rate: {
      label: 'Puhelujen läpimenoprosentti',
      description:
        'Prosenttiosuus puhelinnumeron näyttökerroista, jotka johtivat varsinaiseen puheluun (puhelut ÷ näyttökerrat).',
    },
    directions: {
      label: 'Reittiohjeet',
      description: 'Kuinka monta kertaa käyttäjät klikkasivat saadakseen reittiohjeet yritykseesi.',
    },
    daily_budget: {
      label: 'Päiväbudjetti',
      description: 'Tälle kampanjalle asetettu suurin päiväkohtainen kulutus.',
    },
    status: {
      label: 'Tila',
      description: 'Kampanjasi nykyinen käynnissäolotila.',
    },
    ctr: {
      label: 'Klikkausprosentti',
      description: 'Mainosnäyttöjen prosenttiosuus, joka johti klikkaukseen (klikkaukset ÷ näyttökerrat).',
    },
    average_cpc: {
      label: 'Keskimääräinen klikkaushinta',
      description:
        'Keskimääräinen summa, jonka maksat jokaisesta mainoksesi klikkauksesta (kokonaiskustannus ÷ klikkaukset).',
    },
    conversions_from_interactions_rate: {
      label: 'Konversioprosentti',
      description: 'Mainosvuorovaikutusten prosenttiosuus, joka johti konversioon.',
    },
    start_date: {
      label: 'Aloituspäivä',
      description: 'Kampanjan aloituspäivä.',
    },
    sales_from_google_ads: {
      label: 'Myynti Google Adsin kautta',
      description: 'Google Adsin kautta syntynyt rahamäärä yhteensä.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Ei määritetty',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Käytössä',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Keskeytetty',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Tuntematon',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Poistettu',
  },
  error_messages: {
    loading_failed: 'Kampanjan tietojen lataaminen epäonnistui. Yritä uudelleen.',
  },
};
